import { FC, useContext } from "react";
import { Link } from "react-router-dom";

import { objectToQueryString } from "src/helpers";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { AuthContext } from "src/context/authContext";



const CustomComponentAreaCaseBySubmission: FC<StatisticsObjectType> = ({
  StatisticsObjectType,
  title,
  queryParams,
}): JSX.Element => {
  const {userData} = useContext(AuthContext);
  return (
    <div className="row gx-2">
      <div className="col-12 col-lg-4 mb-3">
        <div className="card">
          <div className="card-header">
            <h1 className="m-0 text-center">DBMs
            </h1>
          </div>
          <div className="card-body p-0" style={{maxHeight:'500px', overflow:'auto'}}>
            <table className="table table-responsive table-hover">
              <thead className="table-light sticky-top">
                <tr className="text-center">
                  <th className="text-white">Name</th>
                  <th className="text-white">Cases</th>
                </tr>
              </thead>
              <tbody>
                {StatisticsObjectType.dbms &&
                  StatisticsObjectType.dbms.data &&
                  StatisticsObjectType.dbms.data.length > 0 &&
                  StatisticsObjectType.dbms.data.map((item, key) => (
                    <tr className="text-center" key={key}>
                      <td>
                        <Link
                          to={{
                            pathname: `/dbm/${item.id}`,
                            search: objectToQueryString(
                              queryParams
                                ? {
                                    start_date: queryParams.start_date,
                                    end_date: queryParams.end_date,
                                    period: queryParams.period,
                                    filter_type: queryParams.filter_type,
                                    case_filter: queryParams.case_filter,
                                    age_group: queryParams.age_group,
                                    id: item.id,
                                    role: "dbm",


                                  }
                                : {}
                            ),
                          }}
                          className="p-0 btn btn-link"
                        >
                          {item.name}
                        </Link>
                      </td>
                      <td>{item.cases || ""}</td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr className="text-center">
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">{StatisticsObjectType?.dbms?.total ?? 0}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
        <div className="col-12 col-lg-4 mb-3">
          <div className="card">
            <div className="card-header">
              <h1 className="m-0 text-center">PN Leads</h1>
            </div>
            <div className="card-body p-0" style={{maxHeight:'500px', overflow:'auto'}}>
              <table className="table table-responsive table-hover">
                <thead className="table-light sticky-top">
                  <tr className="text-center">
                    <th className="text-white">Name</th>
                    <th className="text-white">Cases</th>
                    </tr>
              </thead>
              <tbody>
                {StatisticsObjectType.pn_leads &&
                  StatisticsObjectType.pn_leads.data &&
                  StatisticsObjectType.pn_leads.data.length > 0 &&
                  StatisticsObjectType.pn_leads.data.map((item, key) => (
                    <tr className="text-center" key={key}>
                      <td>
                        <Link
                          to={{
                            pathname: `/patientNavigatorLeads/${item.id}`,
                            search: objectToQueryString(
                              queryParams
                                ? {
                                    start_date: queryParams.start_date,
                                    end_date: queryParams.end_date,
                                    period: queryParams.period,
                                    filter_type: queryParams.filter_type,
                                    case_filter: queryParams.case_filter,
                                    age_group: queryParams.age_group,
                                    id: item.id,
                                    role: "pn_lead"
                                  }
                                : {}
                            ),
                          }}
                          
                          className="p-0 btn btn-link"
                        >
                          {item.name}
                        </Link>
                      </td>
                      <td>{item.cases || ""}</td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr className="text-center">
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">{StatisticsObjectType?.pn_leads?.total ?? 0}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-4 mb-3">
          <div className="card">
            <div className="card-header">
              <h1 className="m-0 text-center">KAM Leads</h1>
            </div>
            <div className="card-body p-0" style={{maxHeight:'500px', overflow:'auto'}}>
              <table className="table table-responsive table-hover">
                <thead className="table-light sticky-top">
                  <tr className="text-center">
                    <th className="text-white">Name</th>
                    <th className="text-white">Cases</th>
                    </tr>
              </thead>
              <tbody>
                {StatisticsObjectType.kam_leads &&
                  StatisticsObjectType.kam_leads.data &&
                  StatisticsObjectType.kam_leads.data.length > 0 &&
                  StatisticsObjectType.kam_leads.data.map((item, key) => (
                    <tr className="text-center" key={key}>
                      <td>
                        <Link
                          to={{
                            pathname: `/kamleads/${item.id}`,
                            search: objectToQueryString(
                              queryParams
                                ? {
                                    start_date: queryParams.start_date,
                                    end_date: queryParams.end_date,
                                    period: queryParams.period,
                                    filter_type: queryParams.filter_type,
                                    case_filter: queryParams.case_filter,
                                    age_group: queryParams.age_group,
                                    id: item.id,
                                    role: "kam_lead"
                                  }
                                : {}
                            ),
                          }}
                          className="p-0 btn btn-link"
                        >
                          {item.name}
                        </Link>
                      </td>
                      <td>{item.cases || ""}</td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr className="text-center">
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">{StatisticsObjectType?.kam_leads?.total ?? 0}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomComponentAreaCaseBySubmission;
